import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const CollapsibleToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 14px 0;
  font-family: ${v2FontFamily};

  p {
    margin: 0;
    font-size: 14px;
    color: ${v2Colors.textMuted};
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding: 6px 4px;
    border: none;
    background: none;
    font-family: inherit;
    color: ${v2Colors.primary};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      color: ${v2Colors.primaryHover};
    }

    svg {
      width: 10px;
      height: 10px;
      transition: transform 150ms ease;
    }
  }

  /* On a narrow screen the bare text button stranded on its own line reads
     as weak — stack it as a full-width outlined control instead. */
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    button {
      justify-content: center;
      padding: 10px 12px;
      border: 1.5px solid ${v2Colors.primary};
      border-radius: 12px;
    }
  }
`;

// CSS-only accordion (grid-template-rows 0fr -> 1fr) — no JS height
// measurement needed, works with dynamic content.
export const CollapsibleBody = styled.div`
  display: grid;
  grid-template-rows: ${(props) => (props.$open ? '1fr' : '0fr')};
  transition: grid-template-rows 250ms ease;

  > div {
    overflow: hidden;
  }
`;
